import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import {connect} from 'react-redux';
import {getCharges} from 'actions';

class Charges extends React.Component {
    constructor(props) {
        super(props);
        this.displayName = 'Charges';
    }
    componentWillMount() {
    	this.props.dispatch(getCharges({limit : 10}));
    }
    render() {
        return <div>
        	<table className="table mb-none">
        		<thead>
        			<tr>
        				<th>#</th>
        				<th>Date</th>
        				<th>Description</th>
        				<th>Card</th>
        				<th>Status</th>
        				<th>Price</th>
        			</tr>
        		</thead>
        		<tbody>
        			{this.props.charges && this.props.charges.length > 0? this.props.charges.map((row, index) => {
        				return (
        					<tr>
        						<td>{index + 1}</td>
        						<td>{moment(row.created * 1000).format('MM/DD/YYYY')}</td>
        						<td>{row.metadata.mapTitle ? row.metadata.mapTitle : row.description}</td>
        						<td>Ending in {row.source.last4}</td>
        						<td>{(()=>{
        							if(row.refunded)
        								return "Refunded";
        							else if(row.paid)
        								return "Paid"
        							else
        								return "Unpaid"
        						})()}</td>
        						<td>${(Number(row.amount)/100).toFixed(2)}</td>
        					</tr>
        				)
        			}) : <tr><td className="text-center" colSpan="6">No charges yet.</td></tr>}
        		</tbody>
        	</table>

        </div>;
    }
}

const mapStateToProps = ({account}) => {
	return {
		charges : account.charges ? account.charges.data : []
	}
}

export default connect(mapStateToProps)(Charges);



// WEBPACK FOOTER //
// ./src/browser/components/account/charges.js